// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-container {
    max-width: 220px;
    text-align: center;
}

.mabe {
    width: 100%;
}

.capacita {
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 0.8;
    color: #047da2;
}

/* Estilos para responsive */
@media (max-width: 768px) {
    .capacita {
        font-size: 25px;
    }

    .logo-container {
        max-width: 190px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/logo/Logo.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".logo-container {\n    max-width: 220px;\n    text-align: center;\n}\n\n.mabe {\n    width: 100%;\n}\n\n.capacita {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 30px;\n    line-height: 0.8;\n    color: #047da2;\n}\n\n/* Estilos para responsive */\n@media (max-width: 768px) {\n    .capacita {\n        font-size: 25px;\n    }\n\n    .logo-container {\n        max-width: 190px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
